import { useEffect, useState } from "react";
import { api, fullUrl } from "../lib/api";

let cache = null;
let inflight = null;

export const invalidateSettings = () => {
    cache = null;
    inflight = null;
};

export const useSettings = () => {
    const [settings, setSettings] = useState(cache || {});

    useEffect(() => {
        if (cache) return;
        if (!inflight) {
            inflight = api
                .get("/settings")
                .then((r) => {
                    cache = r.data;
                    return r.data;
                })
                .catch(() => ({}));
        }
        inflight.then(setSettings);
    }, []);

    return settings;
};

export const useSiteImage = (key, fallback) => {
    const s = useSettings();
    return s[key] ? fullUrl(s[key]) : fallback;
};

export const normalizePhone = (raw) => {
    let d = (raw || "").replace(/\D/g, "");
    if (d.startsWith("00966")) d = d.slice(2);
    else if (d.startsWith("0")) d = "966" + d.slice(1);
    return d;
};

export const useContact = () => {
    const s = useSettings();
    const mobile = s.contact_mobile || "";
    const intl = normalizePhone(mobile);
    return {
        mobile,
        intl,
        callUrl: intl ? `tel:+${intl}` : "#",
        waUrl: (message) => (intl ? `https://wa.me/${intl}?text=${encodeURIComponent(message)}` : "#"),
    };
};
